import { SelectableEnumerationItem } from "../models/lookup.model";
import { EncounterStatus } from "../services/utils";

/** Prior-auth workflow labels on `encounter_status.authStatus` (list-clinic). */
export const ADMISSIONS_AUTH_STATUS_OPTIONS: ReadonlyArray<{
  label: string;
  value: string;
}> = [
  { label: "Pending Auth", value: EncounterStatus.PendingAuth },
  { label: "Authorized", value: EncounterStatus.Authorized },
  { label: "Denied", value: EncounterStatus.Denied },
  { label: "No Auth Required", value: EncounterStatus.NoAuthRequired },
] as const;

export function getAdmissionsAuthStatusFilterOptions(): SelectableEnumerationItem[] {
  return ADMISSIONS_AUTH_STATUS_OPTIONS.map((opt) => ({
    value: opt.value,
    displayName: opt.label,
    isSelected: false,
  }));
}
